<template>
  <v-container class='Login'>

    <v-layout v-if='!isloading' align-center justify-center row wrap h100 mt5>
      <v-flex class='container-login'>
        <v-flex class='login-box'>
          <img src='@/assets/img/logo-super-comics.png' v-if="currentRegion.isoCode === 'BR'" alt='logo' />
          <img src='@/assets/img/logo-super-comics-global.png' v-else alt='logo' />
        </v-flex>

        <button v-if='!sendingForm' class='region' @click='regionsSelect = !regionsSelect;'>
          <img class='region-image'
               :src='`https://cdn.supercomics.com.br/static/flags/${currentRegion.isoCode}.png`'
               alt='País'
          />

          <p class='region-text'>{{ currentRegion.name }}</p>

          <img class='region-arrow' src='@/assets/img/open-region-login.svg' alt='Abrir' />
        </button>

        <div v-if='regionsSelect && !sendingForm'>
          <button class='region' v-for='item in items' @click='selectRegion(item)'>
            <img class='region-image'
                 :src='`https://cdn.supercomics.com.br/static/flags/${item.isoCode}.png`' alt='País' />

            <p class='region-text'>{{ item.name }}</p>

            <img v-if='currentRegion.id === item.id'
                 class='region-arrow' src='@/assets/img/region-checked.svg' alt='Abrir' />
          </button>
        </div>

        <v-flex v-if='!regionsSelect && currentRegion.loginTypes.length > 0'
                class='card pt-3 pb-3 pl-3 pr-3 text-center login-box-card'
                ref='card'>
          <header>
            <h1>{{ $t('title.accessTheClub') }}</h1>
          </header>

          <div card>
            <div class='login-box checkmark-wrap'>
              <svg class='checkmark' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52'>
                <circle class='checkmark__circle' cx='26' cy='26' r='25' fill='none' />
                <path class='checkmark__check' fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8' />
              </svg>
            </div>
          </div>

          <v-form @submit.prevent='auth'>
            <transition name='fade' mode='out-in' tag='v-layout' class='row wrap'>
              <v-flex xs12 key='btnSteps'>
                <v-layout lang row wrap>
                  <v-flex v-if='!sendingForm' xs12>
                    <v-btn
                      type='submit'
                      v-if='currentRegion.loginTypes.includes("PHONE")'
                      :loading='sendingForm'
                      :to='{ name: "loginPhone", params: { regionId: currentRegion.id, isoCode: currentRegion.isoCode }}'
                      color='primary darken-4 white--text full mt-2 elevation-0'
                    >{{ $t('text.signInUsing') }}
                    </v-btn>

                    <v-flex xs12 mt-2 v-if='currentRegion.loginTypes.includes("PARTNER")'>
                      <p class='caption' v-html="$t('text.signInCelphoneText')[0]"></p>
                    </v-flex>

                    <v-btn
                      type='submit'
                      :loading='sendingForm'
                      v-if='currentRegion.loginTypes.includes("PARTNER")'
                      :to='{ name: "partners", params: { regionId: currentRegion.id }}'
                      color='secondary darken-4 white--text full mt-2 elevation-0'
                    >{{ $t('text.signInPartners') }}
                    </v-btn>

                    <v-flex xs12 mt-2 v-if='currentRegion.loginTypes.includes("PARTNER")'>
                      <p class='caption' v-html="$t('text.signInPartnersText')[0]"></p>
                    </v-flex>
                  </v-flex>
                </v-layout>

                <v-flex xs12 mt-4>
                  <p v-if='currentRegion.loginTypes.includes("PHONE")' class='caption'
                     v-html="$t('text.accessTheClub')[0]"></p>
                  <p class='caption mb-0' v-html="$t('text.accessTheClub')[1]"></p>
                </v-flex>
              </v-flex>
            </transition>

            <dialog-default
              :show='dialog.show'
              :title='dialog.title'
              :message='dialog.message'
              :ok='dialog.ok'
              v-on:close='dialogClose'
            ></dialog-default>
          </v-form>
        </v-flex>

        <v-card v-if='!regionsSelect && currentRegion.loginTypes.length === 0'
                class='card pt-3 pb-3 pl-3 pr-3 text-center login-box-card'>
          <p>{{ $t('title.regionUnavailable') }}</p>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout
      v-if='isloading'
      class='loading-login'>
      <v-progress-circular
        :size='70'
        :width='7'
        indeterminate color='primary'
        class='center-block'>
      </v-progress-circular>
    </v-layout>
  </v-container>
</template>

<script>
import DialogDefault from '@/components/dialog/Default';
import axios from 'axios';

export default {
  components: {
    'dialog-default': DialogDefault
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      dialog: {
        show: false,
        title: '',
        message: '',
        ok: () => {}
      },
      countries: ['+55', '+593', '+965', '+971'],

      form: {
        countryCode: '',
        phoneNumber: '',
        confirmationCode: ''
      },
      regionsSelect: false,

      geolocation: {
        latitude: '',
        longitude: ''
      },

      currentRegion: {
        isoCode: '',
        loginTypes: []
      },

      items: [],
      isoCodeImage: '',

      rules: {
        required: v => !!v || this.$t('errors.isRequired')
      },

      isloading: false,
      sendingForm: false,
      idToken: '',
      sms: {
        mode: 'send-sms'
      }
    };
  },
  computed: {},
  methods: {
    // getGeolocation() {
    //   if (!navigator.geolocation) return;
    //   navigator.geolocation.getCurrentPosition((position) => {
    //     this.geolocation.latitude = position.coords.latitude;
    //     this.geolocation.longitude = position.coords.longitude;
    //   });
    // },
    async getRegion() {
      try {
        this.isloading = true;

        const { data } = await axios.get('/external-api/check-ip');
        this.currentRegion = data.currentRegion;
        this.items = data.regions;
        this.$cookies.set('isoCode', data.currentRegion.isoCode);
      } catch (e) {
        this.dialog = {
          show: true,
          message: e.response.data.message,
          title: 'Ops...'
        };
      } finally {
        this.isloading = false;
      }
    },
    selectRegion(item) {
      this.currentRegion = item;
      this.$cookies.set('isoCode', item.isoCode);
      this.regionsSelect = false;
    },
    dialogClose() {
      this.dialog.show = false;
    }
  },
  mounted() {
    this.getRegion();
  }
};
</script>

<style>
dialog {
  height: fit-content !important;
  top: 0 !important;
  bottom: 0 !important;
}

.container-login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.region {
  text-align: start;
  width: fit-content;
  margin: 18px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.region-image {
  border-radius: 100%;
  width: 50px;
  height: 50px;

  @media only screen and (max-width: 720px) {
    width: 45px;
    height: 45px;
  }
}

.region-arrow {
  width: 27px;
  height: 27px;

  @media only screen and (max-width: 720px) {
    width: 17px;
    height: 17px;
  }
}

.region-text {
  color: #fff;
  font-size: 28px;
  line-height: 30px;
  margin-bottom: 0;

  @media only screen and (max-width: 720px) {
    font-size: 20px;
    line-height: 20px;
  }
}

.loading-login {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media only screen and (max-width: 720px) {
    margin-top: 200px;
  }
}
</style>
